import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
      <g transform="translate(26.000000, 23.000000) scale(0.6,0.6)">
        <path
          d="M 50.1 64.7 L 43.5 71.5 L 9.5 38.1 L 9.5 70.3 L 0 70.3 L 0 0.3 L 9.5 0.3 L 9.5 32.2 L 39.3 0 L 45.7 5.9 L 18.4 34.3 L 50.1 64.7 Z"
          fill="currentColor"
        />
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
